/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PromoResponseList } from '../../models/promo-response-list';

export interface PromosSafeGet$Params {
  page: number;
}

export function promosSafeGet(
  http: HttpClient,
  rootUrl: string,
  params: PromosSafeGet$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<PromoResponseList>> {
  const rb = new RequestBuilder(rootUrl, promosSafeGet.PATH, 'get');
  if (params) {
    rb.query('page', params.page, {});
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PromoResponseList>;
      }),
    );
}

promosSafeGet.PATH = '/promos/safe';
